export default __webpack_public_path__ + "static/media/bauhaus-feedback-4.9448d58b.png";